import React from 'react';
import PropTypes from 'prop-types';
import c from 'classnames';

import './_aiAssistantQuickReplies.scss';

const AIAssistantQuickReplies = ({ choices, onSelect, isFloating = false }) => (
  <div className={c('aiAssistantQuickReplies', { 'aiAssistantQuickReplies--floating': isFloating })}>
    {choices.map(choice => (
      <button
        key={choice}
        className="aiAssistantQuickReplies-choice"
        type="button"
        onClick={() => onSelect(choice)}
      >
        {choice}
      </button>
    ))}
  </div>
);

AIAssistantQuickReplies.propTypes = {
  choices: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  isFloating: PropTypes.bool
};

export default AIAssistantQuickReplies;
